import { addReducer } from "incremental-redux-reducers";

const initialState = {
  patients: [],
  meta: {}
};

export default addReducer(
  "locationPatientVeryHighRisk",
  function locationPatientVeryHighRiskReducer(state = initialState, action) {
    switch (action.type) {
      case "LOCATION_VERYHIGHRISK_PATIENT_LOAD":
        return {
          ...state,
          patients: action.patients,
          meta: action.meta
        };
      case "LOCATION_VERYHIGHRISK_PATIENT_LOAD_MORE":
        return {
          patients: [...state.patients, ...action.patients],
          meta: action.meta
        };
      default:
        return state;
    }
  }
);
